// src/components/Loader.js
import React from 'react';
import { useTranslation } from "react-i18next";
import './Loader.css';
import { APP_NAME } from '../../constant/constant';
import logoTara from '../../assets/logo_tara.png';

// Resized, bundled copy (fingerprinted filename, so browsers can cache it long-term)
export const LOGO_SRC = logoTara;

// Three bouncing dots, shared by the overlay and the splash screen
export const LoaderDots = () => (
  <div className="loader-dots" aria-hidden="true">
    <span></span>
    <span></span>
    <span></span>
  </div>
);

// Loader inside a page's content, shown while that page's data loads
export const PageLoader = () => {
  const { t } = useTranslation();
  return (
    <div className="page-loader" role="status" aria-label={t('common.loading')}>
      <LoaderDots />
    </div>
  );
};

// Fullscreen Loader Component
const Loader = ({ isLoading }) => {
  const { t } = useTranslation();
  if (!isLoading) return null;

  return (
    <div className="loader-overlay" role="status" aria-label={t('common.loading')}>
      <div className="loader-card">
        <img className="loader-logo" src={LOGO_SRC} alt={`${APP_NAME} logo`} />
        <LoaderDots />
      </div>
    </div>
  );
};

export default Loader;
